import api from "@/api/orderType";
import { errorHandler } from "../exports/error_management";
import axios from 'axios';
import { StorageCache } from "../exports/dataStorage";

const storageKey = "ams-order-type-key";

const state = {
  item: null,
  items: [],
  filter: '',
  master_docs: [],
};

const getters = {
  activityTypesByPermission: (state, getters, rootState) => {
    const onlyUnique = (value, index, array) => array.indexOf(value) === index;

    const permittedTypeIds = rootState.activity_type_permissions.filter(
      onlyUnique
    );
    console.log("not unique:", rootState.activity_type_permissions);
    console.log("unique permittedTypeIds:", permittedTypeIds);
    console.log("all orderTypes:", state.items);
    if (!state.items || !state.items.length) return [];

    const permittedTypes = state.items.filter((x) =>
      permittedTypeIds.some((permittedId) => permittedId === x.id)
    );

    const unPermittedTypes = state.items.filter(
      (x) => !permittedTypeIds.some((permittedId) => permittedId === x.id)
    );

    permittedTypes.sort((a, b) => {
      let fa = a.name.toLowerCase(),
        fb = b.name.toLowerCase();
      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });

    console.log("permittedTypes:", permittedTypes);
    console.log("unPermittedTypes:", unPermittedTypes);

    return permittedTypes;
  },
};

const mutations = {
  set_item(state, payload) {
    state.item = payload;
  },
  set_items(state, payload) {
    state.items = payload;
  },
  SET_DOCUMENTS(state, types) {
    state.master_docs = types
  },
  updateFilter(state, value) {
    state.filter = value;
  },
};

const actions = {

  set_filter(context, filter) {
    context.commit("updateFilter", filter);
  },
  async create(context, payload) {
    const storageCache = new StorageCache(storageKey);
    try {
      storageCache.reset();
      await api.create(payload);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
  async fetchById(context, id) {
    try {
      id = parseInt(id);
      if (!id) {
        context.commit("set_item", null);
        return;
      }
      const {
        data: {
          success: { data },
        },
      } = await api.fetchById(id);

      console.log("fetch item", data);
      context.commit("set_item", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchAll(context) {
    const storageCache = new StorageCache(storageKey);
    try {
      const { is_valid, value } = storageCache.getArray();
      if (!is_valid) {
        const {
          data: {
            success: { data },
          },
        } = await api.fetchAll();
        storageCache.set(data);
        console.log("orderType fetchall", data);
        value.length = 0;
        value.push(...data);
      }
      context.commit("set_items", value);
    } catch (err) {
      errorHandler(err);
    }
  },
  async fetchAllAfterUpload(context) {
    const storageCache = new StorageCache(storageKey);
    try {
      const { is_valid, value } = storageCache.getArray();
      // if (!is_valid) {
      const {
        data: {
          success: { data },
        },
      } = await api.fetchAll();
      storageCache.set(data);
      console.log("orderType fetchall", data);
      value.length = 0;
      value.push(...data);
      // }
      context.commit("set_items", value);
    } catch (err) {
      errorHandler(err);
    }
  },

  async customerFetchAll(context) {
    try {
      const {
        data: {
          success: { data },
        },
      } = await api.fetchAll();
      context.commit("set_items", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async update(context, payload) {
    const storageCache = new StorageCache(storageKey);
    try {
      console.log("update", payload);
      storageCache.reset();
      await api.update(payload.id, payload);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },

  async delete(context, id) {
    const storageCache = new StorageCache(storageKey);
    try {
      storageCache.reset();
      await api.delete(id);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
  async master_docs(context) {
    try {
      const response = await api.fetchMasterDocs();

      context.commit("SET_DOCUMENTS", response.data.success.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  },
  async fetch_order(context, id) {
    try {
      const response = await api.fetchOrders(id);

      return response.data.success.data;
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  },
  async fetchDefaultType() {
    try {
      const response = await api.fetchDefaultType();

      return response.data.success.data;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
  async fetchDefaultRentalType() {
    try {
      const response = await api.fetchDefaultRentalType();

      return response.data.success.data;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
  async upload(context, payload) {
    try {
      const results = await api.uploadOrderTypes(payload);

      const data = results.data.success.data

      return data
    } catch (err) {
      errorHandler(err)
    }
  },
  async exportExcelCSV(context, { query_at }) {
    try {
      query_at = query_at || '';


      const response = await axios.get(`ordertype/export-excel-csv?q=${query_at}`, {
        responseType: 'blob'
      })
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orderType.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },
  async ExportExcel() {
    try {
      const response = await axios.get(`ordertype/export-excel`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orderType.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },

  async setTransferTypes(context) {
    try {
      console.log("setTransferTypes");
      await api.setTransferTypes();
      context.dispatch("fetchAllAfterUpload");
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
